import { ActivityPlannerTimeslotFragment, CartStatusEnum, TicketCartItemInput } from '../generated/graphql';
import { getCartId } from '../utils/cart';
import { getTicketsInputFromCart, useCart, useSetCart } from './useCart';
import { useRouter } from 'next/router';

export const useUpdateCart = (
    timeslot: ActivityPlannerTimeslotFragment,
    slug: string,
    id?: string,
    isolated?: boolean
) => {
    const cart = useCart();
    const router = useRouter();

    const buyTickets = async () => {
        if (!getCartId()) {
            return;
        }

        const url = isolated ? `/checkout/extras?isolated=true` : '/checkout/extras';
        await router.push(url);
    };
    const { setCart, removeOrderItem } = useSetCart();

    const currentTickets =
        cart.cartQuery.data?.cart?.status === CartStatusEnum.Open
            ? cart.tickets.filter(item => item.activity?.slug === slug)
            : [];

    return async (newTicket: TicketCartItemInput | null) => {
        let tickets = getTicketsInputFromCart(cart?.cartQuery.data?.cart) ?? [];

        // don't use tickets from a stale cart
        if (cart.cartQuery.data?.cart?.status !== CartStatusEnum.Open) {
            tickets = [];
        }
        if (!newTicket) {
            if (!timeslot) {
                return;
            }
            await removeOrderItem(timeslot.id, 'Ticket');
        } else {
            const isEditingTicket = currentTickets.some(ticket => ticket.activity?.id === id);
            if (isEditingTicket) {
                const currIndex = tickets.findIndex(cartTicket => cartTicket.timeslotId === newTicket?.timeslotId);
                tickets[currIndex] = newTicket;
            } else {
                tickets = tickets.concat(newTicket);
            }
            await setCart({
                tickets,
            });
            await buyTickets();
        }
    };
};
